<template>
  <div>
    <div class="grid gap-y-2 gap-x-8 sm:grid-cols-1 md:grid-cols-2">
      <div class="panel">
        <div class="panel-body">
          <Summary :data="summary" />
        </div>
      </div>

      <div class="panel">
        <div class="panel-body">
          <reasons-discard :series="discarded_series" :labels="discarded_labels" />
        </div>
      </div>
    </div>
    <div class="grid gap-y-6 gap-x-8 sm:grid-cols-1">
      <div class="panel">
        <div class="panel-body">
          <accepted-discarded :data="series_ok_discarded" :stats="stats" :height="500" />
        </div>
      </div>
    </div>
    <div class="grid gap-y-2 gap-x-8 sm:grid-cols-1 md:grid-cols-2">
      <div class="panel">
        <div class="panel-body">
          <crop-sizes-dynamic :data="crop_size_summary" :agro_exporter_id="agro_exporter_id"
            :agro_exporter_process_id="agro_exporter_process_id" />
        </div>
      </div>
      <div class="panel">
        <div class="panel-body">
          <crop-sizes-packages-dynamic :data="crop_size_packages_summary" :agro_exporter_id="agro_exporter_id"
            :agro_exporter_process_id="agro_exporter_process_id" />
        </div>
      </div>
    </div>
    <div class="grid gap-y-6 gap-x-8 sm:grid-cols-1">
      <div class="panel">
        <div class="panel-body">
          <crop-size-packages-by-months :data="crop_size_packages_by_months" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Summary from "@/components/views/agro_exporter/production/query_by_provider/charts/Summary.vue";
import ReasonsDiscard from "@/components/views/agro_exporter/production/query_by_provider/charts/ReasonsDiscard.vue";
import AcceptedDiscarded from "@/components/views/agro_exporter/production/query_by_provider/charts/AcceptedDiscarded.vue";
import CropSizesDynamic from "@/components/views/agro_exporter/production/query_by_provider/charts/CropSizesDynamic.vue";
import CropSizesPackagesDynamic from "@/components/views/agro_exporter/production/query_by_provider/charts/CropSizesPackagesDynamic.vue";
import CropSizePackagesByMonths from "@/components/views/agro_exporter/production/query_by_provider/charts/CropSizePackagesByMonths.vue";
export default {
  name: "AEProductionQueryProvidersShowProcessSummary",
  components: {
    Summary,
    ReasonsDiscard,
    AcceptedDiscarded,
    CropSizesDynamic,
    CropSizesPackagesDynamic,
    CropSizePackagesByMonths
  },
  data() {
    return {
      seriesM: this.discarded_motives
    };
  },
  props: {
    agro_exporter_id: { required: true },
    agro_exporter_process_id: { required: true },
    summary: { type: Object, required: true },
    discarded_motives: { required: true },
    providers_summary: { type: Array, required: true },
    crop_size_summary: { type: Array, required: true },
    crop_size_packages_summary: { type: Array, required: true },
    crop_size_packages_by_months: { required: true },
    stats: { type: Object, default: () => { return { summary: { providers: { ok_weight: 0, discarded_weight: 0 } } } } }
  },
  computed: {
    series_ok_discarded() {
      return {
        ok: this.providers_summary.map(p => p.ok_weight),
        discard: this.providers_summary.map(p => p.discarded_weight),
        categories: this.providers_summary.map(p => p.producer.fullname.split(', '))
      };
    },
    discarded_series() {
      return this.discarded_motives.map(dm => dm.value);
    },
    discarded_labels() {
      return this.discarded_motives.map(dm => dm.name);
    }
  }
};
</script>
